import React, { useEffect, useMemo, useState, useRef } from "react";
import {
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { createClient, getAllTenants, updateClients,getAllCountries } from "../../../store/slices/clientsSlice";
import allAPI from "../../../api/api";
import { toast } from "react-toastify";

const bankOptions = [
  { code: "AIRP", name: "AIRTEL PAYMENTS BANK" },
  { code: "ALH", name: "ALLAHABAD BANK" },
  { code: "AXIS", name: "AXIS BANK" },
  { code: "ANDB", name: "ANDHRA BANK" },
  { code: "BOI", name: "BANK OF INDIA" },
  { code: "BHARAT", name: "BHARAT BANK" },
  { code: "BBK", name: "BANK OF BAHRAIN AND KUWAIT" },
  { code: "BOB", name: "BANK OF BARODA" },
  { code: "BOM", name: "BANK OF MAHARASHTRA" },
  { code: "CBI", name: "CENTRAL BANK OF INDIA" },
  { code: "CSB", name: "CATHOLIC SYRIAN BANK" },
  { code: "CANARA", name: "CANARA BANK" },
  { code: "CITI", name: "CITIBANK" },
  { code: "CITIUB", name: "CITY UNION BANK" },
  { code: "CORP", name: "CORPORATION BANK" },
  { code: "COSMOS", name: "COSMOS BANK" },
  { code: "DBS", name: "DEVELOPMENT BANK OF SINGAPORE" },
  { code: "DCB", name: "DCB BANK LIMITED" },
  { code: "DHAN", name: "DHANLAXMI BANK" },
  { code: "DENA", name: "DENA BANK" },
  { code: "DEUTS", name: "DEUTSCHE BANK" },
  { code: "FDEB", name: "FEDERAL BANK" },
  { code: "GPPB", name: "GOPINATH PATIL PARSIK JANATA SAHAKARI BANK LTD" },
  { code: "HDFC", name: "HDFC BANK" },
  { code: "HSBC", name: "HSBC" },
  { code: "ICICI", name: "ICICI BANK" },
  { code: "IDBI", name: "IDBI BANK" },
  { code: "IDFC", name: "IDFC BANK" },
  { code: "INDS", name: "INDUSIND BANK" },
  { code: "INDB", name: "INDIAN BANK" },
  { code: "IOB", name: "INDIAN OVERSEAS BANK" },
  { code: "JSB", name: "JANATA SAHAKARI BANK LTD PUNE" },
  { code: "JKB", name: "JAMMU AND KASHMIR BANK" },
  { code: "KTKB", name: "KARNATAKA BANK" },
  { code: "KVB", name: "KARUR VYSYA BANK" },
  { code: "NKMB", name: "KOTAK BANK" },
  { code: "LVB", name: "LAKSHMI VILAS BANK" },
  { code: "OBPRF", name: "ORIENTAL BANK OF COMMERCE" },
  { code: "PSB", name: "PUNJAB AND SIND BANK" },
  { code: "PYTM", name: "PAYTM PAYMENTS BANK LTD" },
  { code: "PNB", name: "PUNJAB NATIONAL BANK" },
  { code: "RATN", name: "RBL BANK" },
  { code: "RBS", name: "ROYAL BANK OF SCOTLAND" },
  { code: "SCB", name: "STANDARD CHARTERED BANK" },
  { code: "SMALLFB", name: "SMALL FINANCE BANK" },
  { code: "SVC", name: "SVC COOPERATIVE BANK LTD" },
  { code: "SYNBK", name: "SYNDICATE BANK" },
  { code: "STB", name: "SARASWAT BANK" },
  { code: "SIB", name: "SOUTH INDIAN BANK" },
  { code: "SBI", name: "STATE BANK OF INDIA" },
  { code: "TNMB", name: "TAMILNAD MERCANTILE BANK" },
  { code: "UCO", name: "UCO BANK" },
  { code: "USFB", name: "UJJIVAN SMALL FINANCE BANK" },
  { code: "UNI", name: "UNION BANK OF INDIA RETAIL" },
  { code: "UBI", name: "UNITED BANK OF INDIA" },
  { code: "VJYA", name: "VIJAYA BANK" },
  { code: "YES", name: "YES BANK" },
  { code: "JPMC", name: "JPMorgan Chase Bank" },
];

const AddClientsModal = ({ isOpen, toggle, editItem }) => {
  const dispatch = useDispatch();

  const tenantsData = useSelector((state) => state.clients.tenantsData);
  const countries = useSelector((state) => state.clients.allCountries);
  const [tenantStateData, setTenantStateData] = useState(tenantsData);
  const [logoPreview, setLogoPreview] = useState(null);
  const logoInputRef = useRef(null);
  const selectedClientValue = useSelector((state) => state.clients.selectedClient.value);
  const [syncWithPlCrm, setSyncWithPlCrm] = useState(false);

  const defaultValues = useMemo(() => {
    if (editItem && Object.keys(editItem).length > 0) {
      return {
        client_name: editItem.client_name || "",
        country: editItem.country || "",
        client_website: editItem.client_website || "",
        client_email_id: editItem.client_email_id || "",
        client_contact_no: editItem.client_contact_no || "",
        client_gst: editItem.client_gst || "",
        client_pan_no: editItem.client_pan_no || "",
        client_status: editItem.client_status || "",
        client_bank_code: editItem.client_bank_code || "",
        client_toll_free_no: editItem.client_toll_free_no || "",
        tenant_slug: editItem.tenant_slug || selectedClientValue || "",
      
      };
    }else{
       return {
      client_name: "",
      country: "",
      client_website: "",
      client_email_id: "",
      client_contact_no: "",
      client_gst: "",
      client_pan_no: "",
      client_status: "",
      client_bank_code: "",
      client_toll_free_no: "",
      tenant_slug: selectedClientValue || "",
    };
    }
   
  }, [editItem, selectedClientValue]);

  // console.log(editItem,"EDIT ITEM****************");
  // console.log(defaultValues,"DEFAULT_______________");
  

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors,dirtyFields  },
  } = useForm({
    defaultValues: defaultValues,
    values: defaultValues,
    resetOptions: {
      keepDirtyValues: true,
    }
  });

  useEffect(() => {
    dispatch(getAllTenants());
    dispatch(getAllCountries())
  }, [dispatch]);

 
  useEffect(() => {
    if (Array.isArray(tenantsData) && tenantsData.length > 0) {
      setTenantStateData(tenantsData);
    } else {
      if (selectedClientValue) {
        setValue("tenant_slug", {tenantName:`${selectedClientValue}`, tenant_slug:`${selectedClientValue}`});
        setTenantStateData([ {tenantName:`${selectedClientValue}`, tenant_slug:`${selectedClientValue}`}]);
      }
    }

    if (selectedClientValue) {
      setValue("tenant_slug", selectedClientValue);
    }
  }, [tenantsData, selectedClientValue, setValue]);

  useEffect(() => {
    if (isOpen) {
      reset(defaultValues);
      setSyncWithPlCrm(false);
    }
  }, [isOpen, reset, defaultValues]);

  const handleClearLogo = () => {
    setLogoPreview(null);
    setValue("client_logo", null);
    if (logoInputRef && logoInputRef.current) {
      try {
        logoInputRef.current.value = null;
      } catch (err) {
        // ignore - some browsers restrict programmatic clearing of file inputs
      }
    }
  };

  const onSubmit = async (data) => {
    if (selectedClientValue && !data.tenant_slug) {
      data.tenant_slug = selectedClientValue;
    }

    try {
      if (editItem && Object.keys(editItem).length > 0) {
       const changedValues = {};
        
        Object.keys(dirtyFields).forEach((key) => {
          changedValues[key] = data[key];
        });
        if (changedValues.client_logo && changedValues.client_logo.length > 0) {
          try {
            const fd = new FormData();
            fd.append("image", changedValues.client_logo[0]);
            const mediaRes = await allAPI.clients.uploadMedia(fd, selectedClientValue);
            const filename = mediaRes?.data?.data?.image?.[0]?.path
              || mediaRes?.data?.filename
              || mediaRes?.data?.fileName
              || mediaRes?.data?.id
              || mediaRes?.data;
            changedValues.client_logo = filename;
          } catch (err) {
            console.error("Logo upload failed:", err);
          }
        }

        if (Object.keys(changedValues).length === 0) {
            console.log("No changes detected.");
            toggle(); 
            return;
        }

        const updatePayload = {
          id: editItem.ID,
          payload: {...changedValues},
        };
        await dispatch(updateClients(updatePayload));
        console.log("Updating Client:", updatePayload);
      } else {
        const { client_logo, ...restData } = data;
        if (client_logo && client_logo.length > 0) {
          try {
            const fd = new FormData();
            fd.append("image", client_logo[0]);
            const mediaRes = await allAPI.clients.uploadMedia(fd, selectedClientValue);
            const filename = mediaRes?.data?.data?.image?.[0]?.path
              || mediaRes?.data?.filename
              || mediaRes?.data?.fileName
              || mediaRes?.data?.id
              || mediaRes?.data;
            restData.client_logo = filename;
          } catch (err) {
            console.error("Logo upload failed:", err);
          }
        }

        // Tell the backend whether to also create this client on PL-CRM
        // Europassistance (sync-first; if that fails the client isn't created here).
        restData.syncWithPlCrm = syncWithPlCrm;
        const action = await dispatch(createClient(restData));
        if (createClient.rejected.match(action)) {
          // Backend aborted (e.g. PL-CRM sync failed) — show it and keep the
          // modal open so the admin can retry; nothing was created on either side.
          const msg = action.error?.message || "Failed to create client.";
          toast.error(
            syncWithPlCrm ? `PL-CRM sync failed — client not created. (${msg})` : msg,
          );
          return;
        }
        toast.success(
          syncWithPlCrm ? "Client created and synced to PL-CRM." : "Client created successfully.",
        );
        console.log("Creating Client:", action.payload);
      }
      toggle();
    } catch (err) {
      console.error(err);
    }
  };

 return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader>
        {editItem && Object.keys(editItem).length > 0 ? "Edit Client" : "Add Client"}
      </ModalHeader>
      <ModalBody>
        <form id="client-form" onSubmit={handleSubmit(onSubmit)}>
          <div className="px-2">
            <div className="d-flex gap-2 mt-2">
              <div className="w-100">
                <Label>Client Name</Label>
                <input
                  type="text"
                  className={`form-control ${errors.client_name ? "is-invalid" : ""}`}
                  placeholder="Enter Client Name"
                  {...register("client_name", { required: "Name is required" })}
                />
                {errors.client_name && <span className="text-danger small">{errors.client_name.message}</span>}
              </div>
              <div className="w-100">
                <Label>Country</Label>
                <select
                  className={`form-control ${errors.country ? "is-invalid" : ""}`}
                  {...register("country", { required: "Country is required" })}
                >
                  <option value="">Select Country</option>
                  {countries?.map((c) => (
                    <option key={c.iso3} value={c.name}>
                      {c.name}
                    </option>
                  ))}
                </select>
                {errors.country && (
                  <span className="text-danger small">{errors.country.message}</span>
                )}
              </div>
            </div>

            <div className="d-flex gap-2 mt-3">
              <div className="w-100">
                <Label>Client Website</Label>
                <input
                  type="text"
                  className={`form-control ${errors.client_website ? "is-invalid" : ""}`}
                  placeholder="Enter Website"
                  {...register("client_website", { required: "Website is required" })}
                />
                {errors.client_website && <span className="text-danger small">{errors.client_website.message}</span>}
              </div>
            </div>

            <div className="d-flex gap-2 mt-3">
              <div className="w-100">
                <Label>Email</Label>
                <input
                  type="text"
                  className={`form-control ${errors.client_email_id ? "is-invalid" : ""}`}
                  placeholder="Enter Email"
                  {...register("client_email_id", { required: "Email is required" })}
                />
                {errors.client_email_id && <span className="text-danger small">{errors.client_email_id.message}</span>}
              </div>
              <div className="w-100">
                <Label>Contact No</Label>
                <input
                  type="text"
                  className={`form-control ${errors.client_contact_no ? "is-invalid" : ""}`}
                  placeholder="Enter Contact No"
                  {...register("client_contact_no", { required: "Contact is required" })}
                />
                {errors.client_contact_no && <span className="text-danger small">{errors.client_contact_no.message}</span>}
              </div>
            </div>

            <div className="d-flex gap-2 mt-3">
              <div className="w-100">
                <Label>GST No</Label>
                <input
                  type="text"
                  className={`form-control ${errors.client_gst ? "is-invalid" : ""}`}
                  placeholder="Enter GST"
                  {...register("client_gst", { required: "GST is required" })}
                />
                {errors.client_gst && <span className="text-danger small">{errors.client_gst.message}</span>}
              </div>
              <div className="w-100">
                <Label>PAN No</Label>
                <input
                  type="text"
                  className={`form-control ${errors.client_pan_no ? "is-invalid" : ""}`}
                  placeholder="Enter PAN"
                  {...register("client_pan_no", { required: "PAN is required" })}
                />
                {errors.client_pan_no && <span className="text-danger small">{errors.client_pan_no.message}</span>}
              </div>
            </div>

            <div className="d-flex gap-2 mt-3">
              <div className="w-100">
                <Label>Status</Label>
                <select
                  className={`form-control ${errors.client_status ? "is-invalid" : ""}`}
                  {...register("client_status", { required: "Status is required" })}
                >
                  <option value="">Select Status</option>
                  <option value="Active">Active</option>
                  <option value="Deactivated">Deactivated</option>
                </select>
                {errors.client_status && <span className="text-danger small">{errors.client_status.message}</span>}
              </div>
              <div className="w-100">
                <Label>Bank</Label>
                <select
                  className={`form-control ${errors.client_bank_code ? "is-invalid" : ""}`}
                  {...register("client_bank_code", { required: "Bank is required" })}
                >
                  <option value="">Select Bank</option>
                  {bankOptions.map((bank) => (
                    <option key={bank.code} value={bank.code}>{bank.name}</option>
                  ))}
                </select>
                {errors.client_bank_code && <span className="text-danger small">{errors.client_bank_code.message}</span>}
              </div>
            </div>

            <div className="d-flex gap-2 mt-3">
              <div className="w-100">
                <Label>Toll Free No</Label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Toll Free No"
                  {...register("client_toll_free_no")}
                />
              </div>
              <div className="w-100"></div>
            </div>

           
            <div className="d-flex gap-2 mt-3">
              <div className="w-100">
                <Label>Client Logo</Label>
                <input
                  ref={logoInputRef}
                  type="file"
                  accept="image/*"
                  className={`form-control ${errors.client_logo ? "is-invalid" : ""}`}
                  name="client_logo"
                  onChange={(e) => {
                    if (e.target.files && e.target.files[0]) {
                      // keep react-hook-form updated with the FileList
                      setValue("client_logo", e.target.files);
                      setLogoPreview(URL.createObjectURL(e.target.files[0]));
                    } else {
                      setValue("client_logo", null);
                      setLogoPreview(null);
                    }
                  }}
                />
                {logoPreview && (
                  <div style={{ marginTop: 8, display: 'flex', alignItems: 'center', gap: 8 }}>
                    <img src={logoPreview} alt="logo-preview" style={{ height: 80 }} />
                    <button type="button" className="btn btn-sm btn-secondary" onClick={handleClearLogo}>
                      Remove
                    </button>
                  </div>
                )}
                {errors.client_logo && (
                  <span className="text-danger small">{errors.client_logo.message}</span>
                )}
              </div>
            </div>

            {/* Sync with PL-CRM Toggle */}
            <div className="mt-4 p-3" style={{ background: 'linear-gradient(135deg, #f0f4ff 0%, #e8f0fe 100%)', borderRadius: 10, border: '1.5px solid #c3d4f5' }}>
              <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex flex-column" style={{ flex: 1, paddingRight: 16 }}>
                  <span style={{ fontWeight: 600, fontSize: '0.95rem', color: '#1a3a6b', marginBottom: 4 }}>Sync with PL-CRM</span>
                  <small style={{ color: syncWithPlCrm ? '#1a6b3a' : '#6b7280', lineHeight: 1.5 }}>
                    {syncWithPlCrm
                      ? <><span style={{ color: '#16a34a', fontWeight: 600 }}>✓ Sync enabled</span> — This client will also be created in <strong>PL-CRM Europassistance</strong>.</>  
                      : <>Once you enable this, the same client will be generated in the <strong>PL-CRM Europassistance</strong> system.</>
                    }
                  </small>
                </div>
                {/* Custom Toggle Switch */}
                <div
                  onClick={() => setSyncWithPlCrm(!syncWithPlCrm)}
                  id="syncWithPlCrmClientToggle"
                  title={syncWithPlCrm ? 'Disable sync' : 'Enable sync'}
                  style={{
                    width: 52,
                    height: 28,
                    borderRadius: 28,
                    background: syncWithPlCrm ? '#22c55e' : '#cbd5e1',
                    border: syncWithPlCrm ? '2px solid #16a34a' : '2px solid #94a3b8',
                    display: 'flex',
                    alignItems: 'center',
                    padding: '0 3px',
                    cursor: 'pointer',
                    transition: 'background 0.25s, border-color 0.25s',
                    flexShrink: 0,
                    boxShadow: syncWithPlCrm ? '0 0 0 3px rgba(34,197,94,0.2)' : '0 0 0 2px rgba(148,163,184,0.2)',
                  }}
                >
                  <div style={{
                    width: 20,
                    height: 20,
                    borderRadius: '50%',
                    background: '#ffffff',
                    boxShadow: '0 1px 4px rgba(0,0,0,0.25)',
                    transform: syncWithPlCrm ? 'translateX(22px)' : 'translateX(0px)',
                    transition: 'transform 0.25s',
                    flexShrink: 0,
                  }} />
                </div>
              </div>
            </div>

            <div className="w-100 mt-3">
              <Label>Tenant</Label>
              <select
                className={`form-control ${errors.tenant_slug ? "is-invalid" : ""}`}
                {...register("tenant_slug", { required: "Tenant is required" })}
                disabled={selectedClientValue}
              >
                <option value="">Select Tenant</option>
                {tenantStateData?.map((item) => (
                  <option key={item.tenantName} value={item.tenant_slug}>{item.tenantName}</option>
                ))}
              </select>
              {errors.tenant_slug && <span className="text-danger small">{errors.tenant_slug.message}</span>}
            </div>
          </div>
        </form>
      </ModalBody>
      <ModalFooter>
        <button className="btn btn-primary" onClick={handleSubmit(onSubmit)}>
          {editItem && Object.keys(editItem).length > 0 ? "Update" : "Create"}
        </button>
        <button className="btn btn-danger" onClick={toggle}>Cancel</button>
      </ModalFooter>
    </Modal>
  );
};

export default AddClientsModal;